import styled from 'styled-components';

const Button = styled.button`
  color: ${props => props.theme.onPrimary}
  fill: ${props => props.theme.onPrimary}
  width: 140px;
  height: 50px;
  font-size: 14px;
  background: ${props => props.theme.primary};
  border: none;
  text-align: center;
  cursor: pointer;
`;

export default Button;
